import { render } from "./CertifiedDeveloper.vue?vue&type=template&id=0340488d"
import script from "./CertifiedDeveloper.vue?vue&type=script&lang=js"
export * from "./CertifiedDeveloper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__